
<!--
 * @Description: 学生 详情 实习记录
 * @Author: PF
 * @Date: 2023-11-30 10:20:27
 * @LastEditors: PF
 * @LastEditTime: 2025-07-18 12:02:46
-->
<template>
  <div class="hp100" v-if="tableData.length">
    <el-table :data="tableData" border height="100%">
      <el-table-column label="实习计划" prop="sxjhmc" align="center" />
      <el-table-column label="实习单位" prop="sxdwmc" align="center" />
      <el-table-column label="实习岗位" prop="sxgw" align="center" />
      <el-table-column label="薪资" prop="xz" align="center" />
    </el-table>
  </div>
  <el-empty v-else class="hp100" description="暂无记录" />
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { loadSelect } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref([])

watch(
  () => props.row,
  () => {
    if (props.row) {
      loadSelect({ url: '/api/v2/shixi/shixijilu/list', data: tableData, parms: { xsid: props.row.id, order: 'sxksrq', sort: 'desc' } })
    }
  },
  { deep: true, immediate: true }
)
</script>
